// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qu-5";
export var filledCircle = "_qu-4";
export var historyEntry = "_qu-3";
export var messageSideLeft = "_qu-1";
export var messageSideRight = "_qu-2";
export var orderTrackingCarouselWrapper = "_qu-6";
export var orderTrackingInfoContainer = "_qu-0";